import { EvaluatedRight, OdsPriorityGroupsWithGrouped } from "../interfaces/ODSPriorityGroups";
export interface FlattenedEstructural {
    id: number;
    titulo: string;
    descripcion: string;
    estado: number;
    notas: string | null;
    fuente: string | null;
    responsable: string | null;
    tipo_representacion: number;
    tipo_representacionMapa: number;
    tipoIndicador: {
        id: number;
        titulo: string;
        estado: number | null;
        derecho_id: number;
    };
    derecho: {
        id: number;
        titulo: string;
    };
    dimension: {
        id: number;
        titulo: string;
        estado: number | null;
    };
    subdimension: {
        id: number;
        titulo: string;
        estado: number | null;
    };
    evaluaciones: Record<string, string | null>;
}

export function flattenEstructurales(
    data: EvaluatedRight[]
): FlattenedEstructural[] {
    const flattened: FlattenedEstructural[] = [];

    data.forEach((derecho) => {

        derecho.tipos_indicadores?.forEach((tipo) => {
            tipo.dimensiones?.forEach((dim) => {
                dim.subdimensiones?.forEach((sub) => {
                    for (const [year, evals] of Object.entries(sub.evaluaciones || {})) {
                        (evals as any[]).forEach((evalItem) => {
                            flattened.push({
                                id: evalItem.indicador_estructural_id,
                                titulo: evalItem.nombre,
                                descripcion: evalItem.texto,
                                estado: evalItem.estado,
                                notas: null,
                                fuente: null,
                                responsable: null,
                                tipo_representacion: 0,
                                tipo_representacionMapa: 0,
                                tipoIndicador: {
                                    id: tipo.id,
                                    titulo: tipo.nombre,
                                    estado: tipo.trivalente_tipo_indicador,
                                    derecho_id: derecho.id,
                                },
                                derecho: {
                                    id: derecho.id,
                                    titulo: derecho.nombre,
                                },
                                dimension: {
                                    id: dim.id,
                                    titulo: dim.nombre,
                                    estado: dim.trivalente_dimension,
                                },
                                subdimension: {
                                    id: sub.id,
                                    titulo: sub.nombre,
                                    estado: sub.trivalente_subdimension,
                                },
                                evaluaciones: { [year]: evalItem.evaluacion },
                            });
                        });
                    }
                });
            });
        });
    });

    return flattened;
}

export function filterEstructuralesByPeriod(
    data: OdsPriorityGroupsWithGrouped,
    period: string | null
): OdsPriorityGroupsWithGrouped {
    return {
        ...data,
        tipo_indicador: {
            ...data.tipo_indicador,
            Estructurales: period
                ? data.tipo_indicador.Estructurales.filter(
                    (ind) =>
                        ind.evaluaciones &&
                        Object.prototype.hasOwnProperty.call(ind.evaluaciones, period)
                )
                : data.tipo_indicador.Estructurales
        }
    };
}
